import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface FB510 {
  fb510_01: string;        // 產品代號 (PK)
  fb510_05: string;        // 產品類別
  fb510_06: string;        // 文具用途
  fb510_11: string;        // 品名
  fb510_12: string;        // 規格
  fb510_13: string;        // 基本單位
  fb510_15: number;        // 平均單價
  fb510_16: number;        // 現有庫存量
  fb510_18: string;        // 最後採購日期
  fb510_20: number;        // 安全庫存量
  fb510_22: number;        // 在途採購量
  fb510_25: string;        // 主要供應商
  fb510_26: string;        // 貨號
  fb510_27: string;        // 最後報價日期
  fb510_28: number;        // 最後報價單價
  fb510_30: number;        // 期初數量
  fb510_31: number;        // 採購入庫數量
  fb510_32: number;        // 採購退回數量
  fb510_33: number;        // 其他出庫數量
  fb510_34: number;        // 其他入庫數量
  fb510_35: number;        // 領料單數量
  fb510_36: number;        // 退料單數量
  fb510_39: number;        // 盤點調整入數量
  fb510_3a: number;        // 調整單數量
  fb510_40: number;        // 期初金額
  fb510_41: number;        // 採購入庫金額
  fb510_42: number;        // 採購退回金額
  fb510_43: number;        // 其他出庫金額
  fb510_44: number;        // 其他入庫金額
  fb510_45: number;        // 領料單金額
  fb510_46: number;        // 退料單金額
  fb510_49: number;        // 盤點調整入金額
  fb510_4a: number;        // 調整單金額
  fb510_91: string;        // 建立人員
  fb510_92: string | null; // 建立日期
  fb510_93: string;        // 修改人員
}

export interface CreateRequest {
  fb510_01: string;
  fb510_05: string;
  fb510_06: string;
  fb510_11: string;
  fb510_12: string;
  fb510_13: string;
  fb510_15: number;
  fb510_20: number;
  fb510_25: string;
  fb510_26: string;
}

export interface UpdateRequest {
  fb510_05: string;
  fb510_06: string;
  fb510_11: string;
  fb510_12: string;
  fb510_13: string;
  fb510_15: number;
  fb510_20: number;
  fb510_25: string;
  fb510_26: string;
}

export interface ListResponse {
  data: FB510[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// Computed helpers
// ============================================================

export function calcEndingQty(r: FB510): number {
  return r.fb510_30 + r.fb510_31 - r.fb510_32 - r.fb510_33
    + r.fb510_34 - r.fb510_35 + r.fb510_36 + r.fb510_39 + r.fb510_3a;
}

export function calcEndingAmt(r: FB510): number {
  return r.fb510_40 + r.fb510_41 - r.fb510_42 - r.fb510_43
    + r.fb510_44 - r.fb510_45 + r.fb510_46 + r.fb510_49 + r.fb510_4a;
}

// ============================================================
// API methods
// ============================================================

export const officeSuppliesApi = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/office-supplies', { params });
    return res.data;
  },

  async get(code: string): Promise<FB510> {
    const res = await apiClient.get(`/api/office-supplies/${encodeURIComponent(code)}`);
    return res.data;
  },

  async create(data: CreateRequest): Promise<FB510> {
    const res = await apiClient.post('/api/office-supplies', data);
    return res.data;
  },

  async update(code: string, data: UpdateRequest): Promise<FB510> {
    const res = await apiClient.put(`/api/office-supplies/${encodeURIComponent(code)}`, data);
    return res.data;
  },

  async delete(code: string): Promise<void> {
    await apiClient.delete(`/api/office-supplies/${encodeURIComponent(code)}`);
  },

  async copy(sourceCode: string, data: CreateRequest): Promise<FB510> {
    const res = await apiClient.post(`/api/office-supplies/${encodeURIComponent(sourceCode)}/copy`, data);
    return res.data;
  },
};
